import { getApi } from './Api';

export async function listSuppliers({ page, size } = { page: 0, size: 10 }) {
  const api = getApi();
  const { data } = await api.get('/v3/suppliers', { params: { page, size } });
  return data.content;
}
